import { useQuery } from '@apollo/client';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import React from 'react';
import { GET_PROCESS_TYPES, GET_REVIEW_STATUSES } from '../../../utils/statApi/ProcessExtensionApi';
import { IProcessExtensionsListPageState } from './ProcessExtensionsListPage';
import MultiSelectDropdown from '../../common/MultiSelectDropdown';
import IDropdownOption from '../../../utils/types/IDropdownOption';

const dropDownStyles = { width: '200px' };

interface IListFilterProps {
  filterState: IProcessExtensionsListPageState;
  setFilterState: React.Dispatch<React.SetStateAction<IProcessExtensionsListPageState>>;
}

const ListFilter = ({ filterState, setFilterState }: IListFilterProps): JSX.Element => {
  const { loading: loadingStatuses, data: statusData } = useQuery(GET_REVIEW_STATUSES);
  const { reviewStatuses } = !loadingStatuses && statusData ? statusData : { reviewStatuses: [] };

  const { loading: loadingTypes, data: typeData } = useQuery(GET_PROCESS_TYPES);
  const { processTypes } = !loadingTypes && typeData ? typeData : { processTypes: [] };

  const onReviewStatusChange = (
    _event: React.FormEvent<HTMLElement>,
    items: IDropdownOption[],
  ): void => {
    const itemIds = items.map((item) => Number(item.key));
    setFilterState({ ...filterState, statusIds: itemIds });
  };

  const onProcessTypeChange = (
    _event: React.FormEvent<HTMLElement>,
    items: IDropdownOption[],
  ): void => {
    const itemIds = items.map((item) => Number(item.key));
    setFilterState({ ...filterState, processTypeIds: itemIds });
  };

  const onAssignmentFilterChange = (
    _event: React.FormEvent<HTMLElement>,
    items: IDropdownOption[],
  ): void => {
    const itemKeys = items.map((item) => item.key.toString());
    setFilterState({ ...filterState, assignments: itemKeys });
  };

  const assignmentOptions: IDropdownOption[] = [
    { key: 'OWNER', text: 'Owner' },
    { key: 'APPROVER', text: 'Approver' },
  ];

  return (
    <Stack>
      <Stack horizontal tokens={{ childrenGap: 10 }} wrap>
        <MultiSelectDropdown
          label="Assignment"
          onChange={onAssignmentFilterChange}
          selectedKeys={filterState.assignments}
          placeholder="No Filter Selected"
          options={assignmentOptions}
        />
        <MultiSelectDropdown
          label="Status"
          onChange={onReviewStatusChange}
          selectedKeys={filterState.statusIds?.map((id) => id.toString())}
          placeholder="No Filter Selected"
          options={reviewStatuses || []}
          styles={dropDownStyles}
        />
        <MultiSelectDropdown
          label="Process Type"
          onChange={onProcessTypeChange}
          selectedKeys={filterState.processTypeIds?.map((id) => id.toString())}
          placeholder="No Filter Selected"
          options={processTypes || []}
        />
      </Stack>
    </Stack>
  );
};

export default ListFilter;
